import SEO from '../components/SEO';

export default function LegalPage({ title, body, path }) {
  return (
    <>
      <SEO title={`${title} | GradeVIT`} description={body[0]} keywords={`GradeVIT ${title}`} canonicalPath={path} />
      <section className="elevated space-y-4 rounded-2xl border border-brand-border bg-brand-surface p-6">
        <h1 className="text-2xl font-bold">{title}</h1>
        {body.map((paragraph) => <p key={paragraph} className="text-sm leading-6 text-brand-muted">{paragraph}</p>)}
      </section>
    </>
  );
}
